import { LinnworksInstallProduct } from "@redotech/redo-integrations-definitions-common/linnworks/linnworks";
import * as z from "zod";

export const disconnectLinnworksIntegration = {
  name: "disconnectLinnworksIntegration" as const,
  // Omitted product revokes the whole connection (the pre-returns behavior).
  input: z.object({ product: z.enum(LinnworksInstallProduct).optional() }),
  output: z.object({ success: z.boolean() }),
};
